var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckExamplemin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 188,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006781",
    fillRule: "evenodd",
    d: "M174.942 51.971H14.51v84.058h160.432zM7.731 45.192v97.616h173.99V45.192z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006781",
    d: "M22.192 106.654h118.856v6.779H22.192z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5AD4FF",
    d: "M22.192 122.923h30.731v6.779H22.192zm38.414 0h30.731v6.779H60.606z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckExamplemin);
export default __webpack_public_path__ + "static/media/check-example.min.9f15f71138cd9b8960f75d2cbc11baae.svg";
export { ForwardRef as ReactComponent };